// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"tabButton__MMeca"};